import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { ENV_CONFIG } from '../../../constants/envConfig';
import AlertTriangle from '../../../resources/images/alert-triangle.svg';
import Alert from '../../global/atoms/alert/alert';
import { plpDataLocators } from './dataLocators';
import './plp.scss';
import useMedia from '../../../hooks/useMedia';
import { MEDIA_TYPE } from '../../../constants/screenConstants';

const PlpNoResults = props => {
    const intl = useIntl();
    const mediaType = useMedia();
    let breadcrumbList = ENV_CONFIG.BREADCRUMB_LIST_CONTAINER?.querySelectorAll('li') || '';
    let breadcrumbActiveItem = ENV_CONFIG.BREADCRUMB_ACTIVE_LINK?.textContent || '';

    const contactNumber = ENV_CONFIG.SUPPORT_CONTACT_NUMBER || '';
    const [parentTitle, setParentTitle] = useState('');
    const [parentLink, setParentLink] = useState('');
    useEffect(() => {
        if (breadcrumbList) {
            let breadcrumb = breadcrumbList[breadcrumbList.length - 2];
            setParentTitle(breadcrumb?.textContent?.trim() || '');
            setParentLink(breadcrumb?.querySelector('a')?.getAttribute('href') || '');
        }
    }, [breadcrumbList]);

    const getLocationAddress = () => {
        return (
            <>
                {intl.formatMessage({ id: 'plp-product-not-available-text1' })}{' '}
                <a
                    href={`tel:${contactNumber}`}
                    className="plp-no-results__alert-link"
                    title="Call us at"
                    tabIndex={'0'}>
                    {contactNumber}
                </a>{' '}
                {intl.formatMessage({ id: 'plp-product-not-available-text2' })}
            </>
        );
    };

    return (
        <section className="block--cat-hero block--cat-heronoimg">
            <div className="plp-no-results__container" data-testid={plpDataLocators.plp_no_results}>
                <h1 className="plp-no-results__title" tabIndex={'0'}>
                    {breadcrumbActiveItem}
                </h1>

                <div className="plp-no-results__description">
                    <Alert
                        localStyle="plp-no-results__alert"
                        icon={<AlertTriangle aria-hidden={true} tabIndex={'-1'} />}
                        type={'warning'}
                        message={getLocationAddress()}></Alert>

                    <div className="plp-no-results__action">
                        <a
                            href={parentLink}
                            className="plp-no-results__link"
                            tabIndex={'0'}
                            aria-label={`click here for Go back to ${parentTitle}`}>
                            <>{intl.formatMessage({ id: 'plp:go-back' })}</>
                        </a>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default React.memo(PlpNoResults);
